import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';
export function LoginGate() {
  const navigate = useNavigate();
  const handleGoogleLogin = () => {
    // Placeholder for actual Google Auth
    console.log('Google login initiated from gate');
    // In a real app, this would handle auth then redirect back
    // For now, we simulate success by returning to the previous screen
    navigate(-1);
  };
  const handleGoBack = () => {
    navigate(-1);
  };
  return <>
      <Helmet data-id="element-2515">
        <title data-id="element-2516">Sign in to continue | Lazy Monk Labs</title>
        <meta name="robots" content="noindex, nofollow" data-id="element-2517" />
      </Helmet>

      <main className="min-h-screen w-full bg-[#0A0A0A] text-[#F5F5F5] flex flex-col items-center justify-center px-6" data-id="element-2518">
        <div className="w-full max-w-sm" data-id="element-2519">
          {/* Title */}
          <h1 className="text-2xl md:text-3xl text-center mb-4 text-[#F5F5F5]" style={{
          fontFamily: 'Georgia, serif'
        }} data-id="element-2520">
            Sign in to continue
          </h1>

          {/* Body Copy */}
          <p className="text-base text-gray-400 text-center leading-relaxed mb-10" data-id="element-2521">
            To save or share this reflection, we need a way to keep it private
            and associated with you.
          </p>

          {/* Primary Action: Google Login */}
          <button onClick={handleGoogleLogin} className="w-full py-4 bg-[#F5F5F5] text-[#0A0A0A] font-medium rounded-md hover:bg-[#F5F5F5]/90 transition-colors flex items-center justify-center gap-3 mb-6" aria-label="Continue with Google" data-id="element-2522">
            {/* Google Icon SVG from Login.tsx */}
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" data-id="element-2523">
              <path d="M19.6 10.227c0-.709-.064-1.39-.182-2.045H10v3.868h5.382a4.6 4.6 0 01-1.996 3.018v2.51h3.232c1.891-1.742 2.982-4.305 2.982-7.35z" fill="#4285F4" data-id="element-2524" />
              <path d="M10 20c2.7 0 4.964-.895 6.618-2.423l-3.232-2.509c-.895.6-2.04.955-3.386.955-2.605 0-4.81-1.76-5.595-4.123H1.064v2.59A9.996 9.996 0 0010 20z" fill="#34A853" data-id="element-2525" />
              <path d="M4.405 11.9c-.2-.6-.314-1.24-.314-1.9 0-.66.114-1.3.314-1.9V5.51H1.064A9.996 9.996 0 000 10c0 1.614.386 3.14 1.064 4.49l3.34-2.59z" fill="#FBBC05" data-id="element-2526" />
              <path d="M10 3.977c1.468 0 2.786.505 3.823 1.496l2.868-2.868C14.959.99 12.695 0 10 0 6.09 0 2.71 2.24 1.064 5.51l3.34 2.59C5.19 5.736 7.395 3.977 10 3.977z" fill="#EA4335" data-id="element-2527" />
            </svg>
            Continue with Google
          </button>

          {/* Secondary Action: Go Back */}
          <button onClick={handleGoBack} className="w-full text-center text-gray-500 hover:text-[#F5F5F5] text-sm transition-colors" data-id="element-2528">
            Go back
          </button>

          {/* Microcopy */}
          <p className="text-[10px] text-gray-600 text-center mt-8 uppercase tracking-wider" data-id="element-2529">
            No posts. No spam. No commitments.
          </p>
        </div>
      </main>
    </>;
}